// extracted by mini-css-extract-plugin
export var bodySections = "_a6-8";
export var gray = "_a6-7";
export var green = "_a6-4";
export var iconContainer = "_a6-9";
export var iconWidgetContainer = "_a6-1";
export var phoneIcon = "_a6-2";
export var red = "_a6-5";
export var statusDot = "_a6-3";
export var widgetContainer = "_a6-0";
export var yellow = "_a6-6";